import { Expand } from "@ccq/ts-lib";
import { FileUploadProgressDTO } from "@js/DTO/FileUploadProgressDTO.cs.d";
import { BaseService } from "@js/filesfromccqbase/BaseService";
import { BroadcastService } from "@js/filesfromccqbase/BroadcastService";
import { FileAttachment, FileAttachmentClient, ModuleEnum } from "@src/apis/ModularClient";

export class FileAttachmentHelper extends BaseService<FileAttachment, number> {
  static $inject = ["$http", "$cookies", "$rootScope", "$q", "$timeout", "BroadcastService", "FileAttachmentClient"];

  constructor(
    http: ng.IHttpService,
    cookies: ng.cookies.ICookiesService,
    rootScope: ng.IRootScopeService,
    q: ng.IQService,
    timeout: ng.ITimeoutService,
    broadcastservice: BroadcastService,
    private fileAttachmentClient: FileAttachmentClient,
  ) {
    super(http, cookies, rootScope, q, timeout, broadcastservice);
  }

  UploadFileLstInSync(
    files,
    uploadingFiles: FileUploadProgressDTO[],
    objectid: number,
    fileLstOutput: Expand<FileAttachment, {}>[],
    module?: ModuleEnum,
    caseLenderId?: number,
  ): ng.IPromise<string> {
    let defer = this.$q.defer<string>();
    let file = files.pop();
    if (!uploadingFiles) {
      uploadingFiles = [];
    }
    if (file) {
      let tmpfile: FileUploadProgressDTO = {
        uploadingFile: file.name,
        uploadPercent: 0,
      };
      uploadingFiles.push(tmpfile);
      //Get link needed to upload file
      this.fileAttachmentClient
        .getAmazonFileUploadUri(file.name, file.type, objectid, module, caseLenderId)
        .then((fileattach: FileAttachment) => {
          //send file up
          // this.$http.put(fileattach.TempUploadURL, files[0], { headers: { 'Content-Type': type }, uploadEventHandlers: {} })
          this.$http({
            method: "PUT",
            url: fileattach.tempUploadURL,
            data: file,
            headers: { "Content-Type": file.type },
            //eventHandlers: {
            //    readystatechange: function (event: any) {
            //        if (event.currentTarget.readyState === 4) {
            //        }
            //    }
            //},
            uploadEventHandlers: {
              progress(evt: any) {
                tmpfile.uploadPercent = 100.0 * (evt.loaded / evt.total);
              },
            },
          })
            .then((response) => {
              //file now sent up
              //save attachment record to srever
              this.fileAttachmentClient.addUpdateReturnOnlyID(fileattach).then((id) => {
                //append to list of files
                fileattach.id = id;
                fileLstOutput.push(fileattach);
                //remove the object
                if (uploadingFiles) {
                  uploadingFiles.splice(uploadingFiles.indexOf(tmpfile));
                  //hide uploads of all done
                  if (uploadingFiles.length === 0) {
                    uploadingFiles = null;
                  }
                }
              });
              // this.$scope.$apply();
            })
            .catch((response) => {
              if (uploadingFiles) {
                uploadingFiles.splice(uploadingFiles.indexOf(tmpfile));
              }
              //hide uploads of all done
              if (uploadingFiles.length === 0) {
                uploadingFiles = null;
              }
            });
        })
        .finally(() => {
          this.UploadFileLstInSync(files, uploadingFiles, objectid, fileLstOutput, module, caseLenderId);
        });
      return defer.promise;
    }
  }

  uploadFileAndReturnURI(newFile): ng.IPromise<FileAttachment> {
    let defer = this.$q.defer<FileAttachment>();

    var file = newFile.pop();

    if (file) {
      let tmpfile: FileUploadProgressDTO = {
        uploadingFile: file.name,
        uploadPercent: 0,
      };

      return this.fileAttachmentClient
        .getAmazonFileUploadURL(file.name, file.type)
        .then((fileattach: FileAttachment) => {
          //send file up
          this.$http({
            method: "PUT",
            url: fileattach.tempUploadURL,
            data: file,
            headers: { "Content-Type": file.type },
            uploadEventHandlers: {
              progress(evt: any) {
                tmpfile.uploadPercent = 100.0 * (evt.loaded / evt.total);
              },
            },
          }).then((response) => {
            defer.resolve(fileattach as FileAttachment);
          });

          return defer.promise;
        });
    }
  }

  /**
   * Upload a file to the public image folder on AWS
   * @param newImage
   */
  uploadPublicImage(newImageFile, orgCode: string): ng.IPromise<string> {
    let defer = this.$q.defer<string>();

    var file = newImageFile.pop();

    if (file) {
      let tmpfile: FileUploadProgressDTO = {
        uploadingFile: file.name,
        uploadPercent: 0,
      };

      this.fileAttachmentClient.getPublicImageUrl(file.name, file.type, orgCode).then((imageUrl: string) => {
        //send file up
        this.$http({
          method: "PUT",
          url: imageUrl,
          data: file,
          headers: { "Content-Type": file.type },
          uploadEventHandlers: {
            progress(evt: any) {
              tmpfile.uploadPercent = 100.0 * (evt.loaded / evt.total);
            },
          },
        }).then((response) => {
          // remove the pre-signed info from the url
          var url = imageUrl.substr(0, imageUrl.indexOf("?"));
          defer.resolve(url);
        });
      });
    } else {
      defer.resolve();
    }

    return defer.promise;
  }
}
